import React, { useEffect, useRef } from 'react';
import { ImageComponent } from '../../shared/components/common/image_component';
import { Picture } from '../../data/models/product_list_response';
import { constants } from '../../config';

function CarouselItem(props: { picture: Picture }) {
  const containerRef = useRef(null);

  const getImageUrl = (file: Picture) => {
    const url = `${constants.API}/media/MediaContent?filePath=${file.filePath}&fileName=${file.fileName}`;
    return url;
  };

  useEffect(() => {
    const container: any = containerRef.current;
    const imageUrl = getImageUrl(props.picture);
    container.style.backgroundImage = `url(${imageUrl})`;
  }, [props.picture]);

  return (
    <div className="carousel-item w-full h-72 relative rounded-box overflow-clip" key={''}>
      <div
        ref={containerRef}
        className="object-cover bg-cover bg-gray-400 max-w-lg mx-auto h-full w-full rounded-box border blur-md"
        // alt="product-image-blur"
      />
      <ImageComponent
        src={getImageUrl(props.picture)}
        htmlClass="absolute object-contain mx-auto w-full h-full rounded-box bg-black bg-opacity-0 border z-50"
        htmlAlt="product-image"
      />
    </div>
  );
}

export default CarouselItem;
